module.exports = __webpack_public_path__ + "img/bike.67a5acb3.svg";